import { OUTNESS_OPTIONS } from '../OUTNESS_OPTIONS';
import { OutnessOptionIdType } from '../types';

export const getOutnessTitleById = (
  id: OutnessOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return OUTNESS_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: OutnessOptionIdType = 'open_proud';
export const getOutnessIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): OutnessOptionIdType | null => {
  const id = OUTNESS_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
